import { DEFAULT_BASE_URL } from "../features/auth/constants/authConstants";

const rawApiBaseURL = process.env.REACT_APP_API_BASE_URL || DEFAULT_BASE_URL;

export const appConfig = Object.freeze({
  apiBaseURL: rawApiBaseURL.replace(/\/$/, ""),
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
  allowDevTools: process.env.REACT_APP_ALLOW_DEVTOOLS === "true",
  sessionStoragePrefix: "mps_web",
});

export function assertRuntimeConfig() {
  const warnings = [];
  if (!process.env.REACT_APP_API_BASE_URL) {
    warnings.push("REACT_APP_API_BASE_URL não configurado. A usar fallback controlado.");
  }
  if (process.env.NODE_ENV === "production" && appConfig.apiBaseURL.startsWith("http://")) {
    warnings.push("API em HTTP em produção. Preferir HTTPS.");
  }
  return warnings;
}
